/* eslint-disable react/function-component-definition */
import { Link, createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import FunkityLogo from '@/assets/icons/FunkityLogo'
import BankIDLogo from '@/assets/icons/BankIDLogo'
import { AuthSplitLayout } from '@/components/layout/auth-split-layout'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/login/')({
  component: LoginPage,
})

function LoginPage() {
  const { t } = useTranslation()

  return (
    <AuthSplitLayout>
      <div className="flex-1 flex flex-col justify-center w-full md:flex-none md:mb-6 md:space-y-6 ">
        <div className="md:hidden">
          <FunkityLogo className="w-full max-w-40 mx-auto pb-4 text-brand-turkos" />
        </div>
        <div className="flex flex-col gap-y-3">
          <h1 className="text-2xl font-bold md:text-3xl text-center">{t('landingPage.title')}</h1>
          <p className="text-text-secondary text-center">{t('landingPage.description')}</p>
        </div>
      </div>

      <div className="w-full">
        <Link to="/login/bankid">
          <Button className="w-full" size="lg">
            <BankIDLogo className="!size-8" />
            {t('landingPage.loginWithBankIdButton')}
          </Button>
        </Link>
      </div>
    </AuthSplitLayout>
  )
}
